import React from "react";
import {
  Dialog,
  DialogHeader,
  DialogBody,
  DialogFooter,
  Button,
  Typography,
} from "@material-tailwind/react";

const GOOGLE_REVIEW_URL = "https://www.google.com/search?sca_esv=5ed080b9caecffb2&sxsrf=ANbL-n6xwbPunVa1ooNvVQJ2B5_734nwsA:1775914727890&si=AL3DRZEsmMGCryMMFSHJ3StBhOdZ2-6yYkXd_doETEE1OR-qObj-auM36CJalpqGg13bTgMLzpQ9rslti9GBg2urD0H-BqjN7uYtYGJQ37LZ8HSG11ACR9Q0F3H3tTb8V8UV9kEhMtyfOyWcmsdMNHHrL4adrBNsfg%3D%3D&q=Preppo+Prepostos+Coment%C3%A1rios&sa=X&ved=2ahUKEwitlIf09eWTAxWNHbkGHTZGHXkQ0bkNegQILxAH&biw=1536&bih=730&dpr=1.25";
const STORAGE_KEY = "preppo_last_review_popup";
const DAYS_BETWEEN_POPUPS = 7;

interface GoogleReviewPopupProps {
  show: boolean;
  onClose: () => void;
}

const GoogleReviewPopup: React.FC<GoogleReviewPopupProps> = ({ show, onClose }) => {
  const handleReviewNow = () => {
    // Salvar timestamp atual
    localStorage.setItem(STORAGE_KEY, new Date().getTime().toString());
    // Abrir link em nova aba
    window.open(GOOGLE_REVIEW_URL, "_blank", "noopener,noreferrer");
    onClose();
  };

  const handleLater = () => {
    // Salvar timestamp atual para não mostrar novamente tão cedo
    localStorage.setItem(STORAGE_KEY, new Date().getTime().toString());
    onClose();
  };

  return (
    <Dialog open={show} handler={onClose} size="sm">
      <DialogHeader className="text-preppoBlue">
        Avalie a Preppo no Google
      </DialogHeader>
      <DialogBody className="space-y-4">
        <Typography className="text-gray-700">
          Olá! Esperamos que sua experiência com a Preppo tenha sido positiva.
        </Typography>
        <Typography className="text-gray-700">
          Sua avaliação no Google é muito importante para nós e nos ajuda a crescer e melhorar nossos serviços.
        </Typography>
        <Typography className="text-gray-700 font-semibold">
          Poderia nos avaliar? Leva apenas alguns segundos! 🌟
        </Typography>
      </DialogBody>
      <DialogFooter className="space-x-2">
        <Button
          variant="text"
          color="gray"
          onClick={handleLater}
        >
          Depois
        </Button>
        <Button
          color="blue"
          onClick={handleReviewNow}
        >
          Avaliar agora
        </Button>
      </DialogFooter>
    </Dialog>
  );
};

/**
 * Verifica se deve mostrar o popup de avaliação
 * Retorna true se passaram mais de 7 dias desde a última exibição
 */
export const shouldShowReviewPopup = (): boolean => {
  const lastShown = localStorage.getItem(STORAGE_KEY);
  
  if (!lastShown) {
    return true; // Nunca foi mostrado
  }
  
  const lastShownTime = parseInt(lastShown, 10);
  const now = new Date().getTime();
  const daysSinceLastShown = (now - lastShownTime) / (1000 * 60 * 60 * 24);
  
  return daysSinceLastShown >= DAYS_BETWEEN_POPUPS;
};

export default GoogleReviewPopup;
